<div class="sb-step">
  <section class="bk-panel sb-panel sb-step__main" aria-labelledby="seg-rules-title">
    <h2 class="bk-section-title sb-panel__title" id="seg-rules-title">Conditions</h2>
    <p class="sb-panel__lead">A contact joins this segment when it matches every condition.</p>

    <ol class="sr-list">
      @for (segmentRule of segmentRules; track segmentRule.id; let i = $index) {
        <li class="sr-item">
          @if (i > 0) {
            <span class="sr-join" aria-hidden="true">and</span>
          }
          <segment-rule-card
            [segmentRule]="segmentRule"
            [index]="i"
            [last]="$last"
            [id]="segmentRule.id"
            [error]="showErrors ? errors[i] || '' : ''"
            [canRemove]="segmentRules.length > 1"
            (updateSegment)="handleChildUpdate($event)"
            (removeSegmentRule)="removeSegmentRule($event)"
          />
        </li>
      }
    </ol>

    <button type="button" class="bk-btn bk-btn--ghost sr-add" (click)="addAnotherAttribute()">
      <span class="bk-sym" aria-hidden="true">add</span>
      Add condition
    </button>

    @if (formError) {
      <p class="sb-error" role="alert">
        <span class="bk-sym" aria-hidden="true">error</span>
        {{ formError }}
      </p>
    }

    <div class="sb-bar">
      <div class="sb-bar__group">
        <button type="button" class="bk-btn bk-btn--ghost" (click)="cancel()">Cancel</button>
        <button type="button" class="bk-btn bk-btn--ghost" (click)="goToPrevious()">
          <span class="bk-sym" aria-hidden="true">arrow_back</span>
          Previous
        </button>
      </div>
      <div class="sb-bar__group">
        <button type="button" class="bk-btn bk-btn--primary" (click)="goToReviewPage()">
          Next: review
          <span class="bk-sym sr-next" aria-hidden="true">arrow_forward</span>
        </button>
      </div>
    </div>
  </section>

  <div class="sb-step__aside sb-step__aside--preview">
    <segment-preview [rules]="segmentRules" />
  </div>
</div>
